import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/login/page.tsx");
